/*
 * @Description: 路由
 * @Author: 山淑兰
 * @Date: 2019-12-17 11:06:41
 * @LastEditTime: 2020-07-08 10:35:08
 * @LastEditors: 山淑兰
 */
import { RouteConfig } from "vue-router";

const prefix = "";

const COMMON = {
  LOGIN: `${prefix}/login`,
  ELOGIN: `${prefix}/eLogin`,
  TRANSITION: `${prefix}/transition`,
  PAY: `${prefix}/pay`,
  SCHEDULES: `${prefix}/schedules`,
  GUEST: `${prefix}/guest`,
  LIVEINFO: `${prefix}/liveInfo`,
  PHOTOLIST: `${prefix}/photoList`,
  gh: `${prefix}/gh`,
  INITPAGE: `${prefix}/initPage`,
};

const Routers: RouteConfig[] = [
  /**
   * @description: 登录
   */
  {
    path: COMMON["LOGIN"],
    meta: { isBreadCrumbs: true },
    component: () => import(/* webpackChunkName: "login" */ "../../../views/SignUp/Login.vue"),
  },
  /**
   * @description: 嘉宾登录
   */
  {
    path: COMMON["ELOGIN"],
    meta: { isBreadCrumbs: true },
    component: () => import(/* webpackChunkName: "login" */ "../../../views/SignUp/eLogin.vue"),
  },
  /**
   * @description: 过渡页
   */
  {
    path: COMMON["TRANSITION"],
    meta: { isBreadCrumbs: true },
    component: () =>
      import(/* webpackChunkName: "transition" */ "../../../views/Common/Transition.vue"),
  },
  /**
   * @description: 日程
   */
  {
    path: COMMON["SCHEDULES"],
    name: "schedules",
    meta: { isBreadCrumbs: true },
    component: () =>
      import(/* webpackChunkName: "schedules" */ "@/views/PersonalCenter/Modules/Schedules-new.vue"),
  },
  /**
   * @description: 嘉宾登录成功页面
   */
  {
    path: COMMON["INITPAGE"],
    meta: { isBreadCrumbs: true },
    component: () => import(/* webpackChunkName: "login" */ "../../../views/export/initPage.vue"),
  },
  /**
   * @description: 嘉宾
   */
  {
    path: COMMON["GUEST"],
    name: "guest",
    meta: { isBreadCrumbs: true },
    component: () =>
      import(/* webpackChunkName: "schedules" */ "@/views/PersonalCenter/Modules/guest.vue"),
  },
  /**
   * @description: 直播
   */
  {
    path: COMMON["LIVEINFO"],
    name: "liveInfo",
    meta: { isBreadCrumbs: true },
    component: () =>
      import(/* webpackChunkName: "liveInfo" */ "../../../views/Live/LiveInfo.vue"),
  },
  /**
   * @description: 照片直播
   */
  {
    path: COMMON["PHOTOLIST"],
    name: "liveInfo",
    meta: { isBreadCrumbs: true },
    component: () =>
      import(/* webpackChunkName: "liveInfo" */ "../../../views/Photo/photoList.vue"),
  },
];

export default Routers;
